/* ==========================================================================
   PALLMILLA HOMEPAGE — hm-home.js  (vanilla ES module, no dependencies)
   Everything works without JS; this only enhances. Loaded index-only, deferred.
   ========================================================================== */
const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
const HOVER = matchMedia('(hover: hover) and (pointer: fine)').matches;
const $  = (s, r = document) => r.querySelector(s);
const $$ = (s, r = document) => [...r.querySelectorAll(s)];

/* 1. header transparent -> solid over hero ------------------------------- */
function headerState() {
  const header = $('[data-hm-header]'); const sentinel = $('[data-hm-sentinel]');
  if (!header || !sentinel || !('IntersectionObserver' in window)) return;
  header.dataset.hmHeader = 'transparent';
  new IntersectionObserver(([e]) => {
    header.dataset.hmHeader = e.isIntersecting ? 'transparent' : 'solid';
  }, { rootMargin: '-72px 0px 0px 0px' }).observe(sentinel);
}

/* 2. announcement rotator ------------------------------------------------- */
function announcementRotator() {
  const root = $('[data-hm-announce]'); if (!root) return;
  const msgs = $$('[data-hm-msg]', root); if (msgs.length < 2) return;
  if (RM) { msgs.forEach((m, i) => m.dataset.active = i === 0 ? 'true' : 'false'); return; }
  let i = 0, timer;
  const show = n => msgs.forEach((m, k) => m.dataset.active = k === n ? 'true' : 'false');
  const start = () => { clearInterval(timer); timer = setInterval(() => show(i = (i + 1) % msgs.length), 5000); };
  show(0); start();
  root.addEventListener('mouseenter', () => clearInterval(timer));
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', () => clearInterval(timer));
  root.addEventListener('focusout', start);
}

/* 3. mega menu (hover intent + click + keyboard) ------------------------- */
function megaMenu() {
  const header = $('[data-hm-header]'); if (!header) return;
  const triggers = $$('[data-hm-mega-trigger]', header);
  let openT, closeT, current = null;
  const panel = id => document.getElementById(id);
  const closeAll = () => {
    triggers.forEach(t => { t.setAttribute('aria-expanded', 'false'); const p = panel(t.getAttribute('aria-controls')); if (p) p.hidden = true; });
    current = null;
  };
  const open = (t) => {
    if (current === t) return;
    closeAll(); const p = panel(t.getAttribute('aria-controls')); if (!p) return;
    p.hidden = false; t.setAttribute('aria-expanded', 'true'); current = t;
  };
  triggers.forEach(t => {
    const p = panel(t.getAttribute('aria-controls')); if (p) p.hidden = true;
    t.setAttribute('aria-expanded', 'false');
    if (HOVER) {
      t.addEventListener('mouseenter', () => { clearTimeout(closeT); openT = setTimeout(() => open(t), 120); });
      t.addEventListener('mouseleave', () => { clearTimeout(openT); closeT = setTimeout(closeAll, 180); });
      p && p.addEventListener('mouseenter', () => clearTimeout(closeT));
      p && p.addEventListener('mouseleave', () => { closeT = setTimeout(closeAll, 180); });
    }
    t.addEventListener('click', (e) => { e.preventDefault(); current === t ? closeAll() : open(t); });
    t.addEventListener('keydown', (e) => {
      const idx = triggers.indexOf(t);
      if (e.key === 'ArrowRight') { e.preventDefault(); triggers[(idx + 1) % triggers.length].focus(); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); triggers[(idx - 1 + triggers.length) % triggers.length].focus(); }
      if (e.key === 'ArrowDown')  { e.preventDefault(); open(t); const f = p && $('a', p); f && f.focus(); }
    });
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', e => { if (current && !header.contains(e.target)) closeAll(); });
}

/* 4. mobile drawer -------------------------------------------------------- */
function drawer() {
  const btn = $('[data-hm-drawer-open]'); const dlg = $('[data-hm-drawer]'); if (!btn || !dlg) return;
  btn.addEventListener('click', () => dlg.showModal());
  $$('[data-hm-drawer-close]', dlg).forEach(b => b.addEventListener('click', () => dlg.close()));
  dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });
}

/* 5. reveal fallback (only when scroll-timeline unsupported) -------------- */
function reveal() {
  if (CSS.supports('animation-timeline: view()')) return;
  const els = $$('.hm-reveal'); if (!els.length || !('IntersectionObserver' in window)) return;
  const io = new IntersectionObserver((ents) => {
    ents.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { threshold: .15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(el => io.observe(el));
}

/* 6. count-up ------------------------------------------------------------- */
function countUp() {
  const els = $$('[data-count]'); if (!els.length) return;
  const run = (el) => {
    const end = parseFloat(el.dataset.count); const dec = (el.dataset.count.split('.')[1] || '').length;
    if (RM) { el.textContent = new Intl.NumberFormat(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(end); return; }
    const t0 = performance.now(), dur = 1400;
    const step = (t) => {
      const p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = new Intl.NumberFormat(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec }).format(end * e);
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };
  const io = new IntersectionObserver((ents) => ents.forEach(e => { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } }), { threshold: .4 });
  els.forEach(el => io.observe(el));
}

/* 7. row scroller (prev/next + progress) ---------------------------------- */
function rowScroller() {
  $$('[data-hm-row]').forEach(root => {
    const track = $('[data-hm-row-track]', root); if (!track) return;
    const prev = $('[data-hm-prev]', root), next = $('[data-hm-next]', root), fill = $('[data-hm-row-fill]', root);
    const step = () => (track.firstElementChild?.getBoundingClientRect().width || 300) + 20;
    const upd = () => {
      const max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      if (fill) fill.style.inlineSize = max > 0 ? (track.scrollLeft / max) * 100 + '%' : '100%';
    };
    prev && prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }));
    next && next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(upd), { passive: true });
    track.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); track.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); }
    });
    upd();
  });
}

/* 8. WAI-ARIA tabs -------------------------------------------------------- */
function tabs() {
  $$('[data-hm-tabs]').forEach(root => {
    const btns = $$('[role="tab"]', root);
    /* the spotlight has TWO panel sets per tab: the media figure and the copy/spec
       panel. Collecting every [role="tabpanel"] gave a 4-item list against 2 tabs,
       so the spec panels were never toggled. Track each set by tab index instead. */
    const media = $$('[data-hm-tabpanel]', root);
    const copy  = $$('.hm-spot__panel', root);
    const sel = (i) => {
      btns.forEach((b, k) => {
        const on = k === i; b.setAttribute('aria-selected', on); b.tabIndex = on ? 0 : -1;
      });
      media.forEach((p, k) => { p.hidden = k !== i; });
      copy.forEach((p, k) => { p.hidden = k !== i; });
    };
    btns.forEach((b, i) => {
      b.addEventListener('click', () => sel(i));
      b.addEventListener('keydown', e => {
        let n = i;
        if (e.key === 'ArrowRight') n = (i + 1) % btns.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + btns.length) % btns.length;
        else if (e.key === 'Home') n = 0; else if (e.key === 'End') n = btns.length - 1; else return;
        e.preventDefault(); sel(n); btns[n].focus();
      });
    });
    sel(btns.findIndex(b => b.getAttribute('aria-selected') === 'true') || 0);
  });
}

/* 9. spotlight image swap (tabs already drive panel visibility) ----------- */
function spotlight() { /* image swap handled by CSS opacity on [hidden] siblings; nothing extra needed */ }

/* 10. pointer glow on need cards ----------------------------------------- */
function pointerGlow() {
  if (!HOVER) return;
  $$('[data-hm-glow]').forEach(card => {
    let raf = 0;
    card.addEventListener('pointermove', e => {
      if (raf) return; raf = requestAnimationFrame(() => {
        const r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px'); raf = 0;
      });
    }, { passive: true });
  });
}

/* 11. quick add ----------------------------------------------------------- */
function quickAdd() {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-hm-add]'); if (!btn) return;
    e.preventDefault(); btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: btn.dataset.hmAdd, quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      document.dispatchEvent(new CustomEvent('hm:cart-updated', { detail: await res.json() }));
      const label = btn.getAttribute('aria-label') || 'Added'; btn.setAttribute('aria-label', 'Added to cart');
      btn.classList.add('is-added');
    } catch (err) {
      const card = btn.closest('.hm-card');
      let msg = card && $('.hm-card__err', card);
      if (card && !msg) { msg = document.createElement('p'); msg.className = 'hm-card__err'; msg.setAttribute('role', 'alert'); card.append(msg); }
      if (msg) msg.textContent = 'Could not add. Please try again.';
    } finally { btn.disabled = false; }
  });
}

/* boot -------------------------------------------------------------------- */
const boot = () => { headerState(); announcementRotator(); megaMenu(); drawer(); reveal(); countUp(); rowScroller(); tabs(); spotlight(); pointerGlow(); quickAdd(); };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
